import { render, staticRenderFns } from "./referralStatement.vue?vue&type=template&id=e22a98dc&scoped=true&"
import script from "./referralStatement.vue?vue&type=script&lang=js&"
export * from "./referralStatement.vue?vue&type=script&lang=js&"
import style0 from "./referralStatement.vue?vue&type=style&index=0&id=e22a98dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22a98dc",
  null
  
)

export default component.exports